import * as React from "react"
import { cn } from "@/lib/utils"

export interface RadioProps extends React.InputHTMLAttributes<HTMLInputElement> {
  label?: string
}

export function Radio({ className, label, ...props }: RadioProps) {
  return (
    <label className="inline-flex items-center gap-2">
      <input
        type="radio"
        className={cn(
          "h-4 w-4 text-primary accent-[var(--primary)]",
          className,
        )}
        {...props}
      />
      {label && <span className="text-sm text-foreground/90">{label}</span>}
    </label>
  )
}
